// Users Admin
export const ADMIN = '/admin';
export const USER_LISTING = '/admin/userListing';
export const USER_RESTRICTIONS = '/admin/userListing/:id/restrictions';
export const USER_FORM = '/admin/userListing/userForm';
export const ROLE_LISTING = '/admin/roleListing';
export const ROLE_FORM = '/admin/roleListing/roleForm/:id';
export const CONTENT_LISTING = '/admin/contentListing';
export const CONTENT_FORM = '/admin/contentListing/contentForm/:id';



// WEBPACK FOOTER //
// ./src/features/users/routes/const.js